import { NgModule } from '@angular/core';
import { NewRouteToTopDirective } from './new-route-to-top.directive';
import { DeleteDialogDirective } from 'app/shared/directives/confirm-delete-dialog.directive';
import { CdkDetailRowDirective } from './cdk-detail-row.directive';
import { MaxValueDirective } from './max-value.directive';
import { DeferLoadDirective } from './defer-load.directive';
import { DatepickerTodayButtonDirective } from './datepicker-today-button.directive';
import { TooltipWhenTruncatedDirective } from './tooltip-when-truncated.directive';
import { CampaignPreviewHoverDirective } from './campaign-preview-hover.directive';
import { TopMenuTitleDirective } from './top-menu-title.directive';

const directives = [
  NewRouteToTopDirective,
  DeleteDialogDirective,
  CdkDetailRowDirective,
  MaxValueDirective,
  DeferLoadDirective,
  DatepickerTodayButtonDirective,
  TooltipWhenTruncatedDirective,
  CampaignPreviewHoverDirective,
  TopMenuTitleDirective,
];

@NgModule({
  declarations: directives,
  exports: directives,
})
export class DirectivesModule {}
